<article class="add-remove-button-container">
  @switch (addRemoveState()) {
    @case (AddRemoveState.ADD) {
      <button (click)="toggleAddRemoveState()" class="add">
        <i class="boschicon-bosch-ic-add-frame"></i> Add
      </button>
    }
    @case (AddRemoveState.REMOVE) {
      <button (click)="toggleAddRemoveState()" class="remove">Remove</button>
    }
  }
</article>
